module.exports = __webpack_public_path__ + "static/media/sms-followup-reminder.412fbf4a.png";